"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AuthorizationData = require("./AuthorizationData");
Object.keys(_AuthorizationData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AuthorizationData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AuthorizationData[key];
    }
  });
});
var _GenesysSubscribeEvent = require("./GenesysSubscribeEvent");
Object.keys(_GenesysSubscribeEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GenesysSubscribeEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GenesysSubscribeEvent[key];
    }
  });
});
var _net = require("./graphql-types/net");
Object.keys(_net).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _net[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _net[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});
